import { connect } from 'react-redux';
import Container from '@mui/material/Container';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import useDataGrid from 'app/hooks/useDataGrid';
//import PhotoSwipeWrapper from 'app/components/PhotoSwipe';
import ErrorModal from 'app/components/ErrorModal';
import classes from './classes.module.scss';
import TopBar from './TopBar';
import LoadingIcon from './LoadingIcon';
import AgGrid from './AgGrid';
import FilterOptions from './FilterOptions';

import {
  selectViewportMobile
} from 'app/reducers/viewportReducer';

import {
  getGridState,
  setGridState
} from 'app/actions/gridState';

import {
  selectGridState
} from 'app/reducers/gridState';

import {
  PAGE_SIZE
} from 'app/utils/Constants';

const DataGrid = props => {
  // props DataGrid accepts
  const {
    // header above the table
    header,

    // rowData can be passed for simple client-side data
    // or getRowData can be passed for server-side data
    rowData,
    getRowData,

    // message to show when loading data from the server
    loadingMessage,

    // arrays of colDef field names to control order, presence and visibility
    columnOrder,
    onlyColumns,
    omitColumns,
    visibleColumns,

    // callbacks to update column order & visibility server-side
    onColumnOrderUpdate,
    onVisibleColumnsUpdate,

    // columnDefOverrides is the same as AG Grid's columnDefs prop,
    // with some extra features added by this component.
    // by default the columnDefs are built from the rowData.
    // any columnDef defined here will override the existing one
    // or create a new one if it wasn't created by the rowData.
    // so this can be used to add new columnDefs (like pinned actions, etc.)
    columnDefOverrides,

    // label and callback for primary button in upper right
    addButtonLabel,
    showAdd,
    onAdd,

    // flag and callback for edit icon on each row
    showEdit,
    onEdit,

    // flag and callbacks for quick edit mode
    quickEditEnabled,
    onQuickAdd,
    onQuickEdit,

    // newRowTemplate is an optional template object that gets merged into
    // each new row created in quick edit mode.
    // example setting the new row's job_id to the first job:
    // const newRowTemplate = {
    //   job_id: jobs && jobs[0] && jobs[0].id
    // }
    newRowTemplate,

    // flag to show row checkboxes
    // and an array of buttons for the Actions dropdown.
    // each button should be an object with a key, label and callback prop
    // ex: [
    //   { key: 'notify', label: 'Notify Customers', callback: selectedRows => {} },
    //   { key: 'destroy', label: 'Delete Customers', callback: selectedRows => {} },
    // ]
    showSelect,
    actions,

    // custom buttons to appear in top bar
    buttons,

    dropDownOptions,
    onDropdownOptionChanged,
    showDropDown,
    dropDownLabel,

    // flag to show filters (as in display, they will still be enabled)
    showFilters,

    // callback to build PhotoSwipe item from row
    setPhotoSwipeItem,

    // resource key for grid state (useGridState)
    resource,

    // pass dataGrid handles to outer resource component (ex: Jobs)
    onDataGridLoad,

    // props from Redux
    isMobile,
    darkMode,
    gridState,

    // dispatch actions
    getGridState,
    setGridState,
    defaultDropdownOption
  } = props;

  const dataGrid = useDataGrid({
    rowData,
    getRowData,
    showAdd,
    onAdd,
    quickEditEnabled,
    onQuickAdd,
    onQuickEdit,
    columnOrder,
    onlyColumns,
    omitColumns,
    visibleColumns,
    onVisibleColumnsUpdate,
    onColumnOrderUpdate,
    columnDefOverrides,
    showEdit,
    onEdit,
    showSelect,
    actions,
    showFilters,
    setPhotoSwipeItem,
    isMobile,
    darkMode,
    dropDownOptions,
    onDropdownOptionChanged,
    showDropDown,
    gridState,
    getGridState,
    setGridState,
    resource,
    onDataGridLoad,
    defaultDropdownOption,
    newRowTemplate
  });

  // get data grid hooks
  const {
    agGrid,
    columns,
    dataSource,
    quickEdit,
    onGridReady,
    onColumnMoved,
    onColumnVisible,
    onColumnPinned,
    photoSwipe
  } = dataGrid;

  // get visible columnDefs.
  // visibility can be toggled off in the columnDef or via the columns select
  const columnDefs = columns.getVisibleColumnDefs(quickEdit.active);

  // determine rowModelType.
  // use infinite for server-side data, unless quick edit mode is active.
  // use clientSide for quick edit mode and the client-side rowData prop
  let rowModelType;
  if (dataSource.enabled && !quickEdit.active) {
    rowModelType = 'infinite';
  } else {
    rowModelType = 'clientSide';
  }

  const gridTheme = darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine';
  const gridClass = `${gridTheme} ${classes.agGrid}`;

  // setup row selection if enabled
  const rowSelection = showSelect ? 'multiple' : null;
  const { onSelectionChanged } = agGrid;

  // show filters if active
  const filtersActive = agGrid.filtersActive;

  // only render grid once grid state is loaded
  let showGrid = !dataGrid.gridState.loading;

  return (
    <Container className="grid-container" maxWidth="false">
      <div className={classes.container}>
        <TopBar {...{
	  resource,
          dataGrid,
          header,
          addButtonLabel,
          actions,
	  buttons,
          isMobile,
          dropDownLabel
        }} />
        <div className={gridClass}>
          <LoadingIcon {...{
            dataGrid,
            loadingMessage
          }} />
          <FilterOptions {...{
	    resource,
	    agGrid
          }}/>
          {showGrid && <AgGrid {...{
            agGrid,
            rowHeight: 4 * 16, // 42 default
            columnDefs,
            rowModelType,
            rowData,
            paginationPageSize: PAGE_SIZE,
            cacheOverflowSize: 2,
            maxConcurrentDatasourceRequests: 1,
            maxBlocksInCache: 10,
            onGridReady,
            rowSelection,
            onSelectionChanged,
            suppressRowClickSelection: true,
            floatingFilter: true,
            enableCellTextSelection: true,
            columnsLastUpdate: columns.lastUpdate,
            onColumnMoved,
            onColumnVisible,
            onColumnPinned
          }} />}
        </div>
      </div>
      <ErrorModal error={dataSource.error} onClose={dataSource.clearError} />
    </Container>
  );
}

const mapStateToProps = (state, ownProps) => ({
  darkMode: state.portalReducer.darkMode,
  isMobile: selectViewportMobile(state),
  gridState: selectGridState(state, ownProps.resource),
});

export default connect(mapStateToProps, { getGridState, setGridState })(DataGrid);
